/**
 * @desc 保存和编辑
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageChannel.save.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageChannel/save`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
